<template>
  <div>
    <el-drawer
      class="el-drawer__header"
      :title="routeInfo.lineName"
      :visible.sync="drawerVisible"
      size="40%"
    >
      <div id="route-info-line" style="font-size: 14px; color: #72767b">
        <el-row>
          <el-col span="12">
            <label>线路名称: </label>
            <span v-text="routeInfo.lineName"></span>
          </el-col>
          <el-col span="12">
            <el-button
              type="primary"
              size="mini"
              id="edit-route-info"
              @click="jumpUrl('/route', lineId)"
              v-has-permi="['transport_route_edit']"
              >编辑</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>原城际线路: </label>
            <span v-text="routeInfo.oldLineName"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>起点城市: </label>
            <span v-text="routeInfo.startCityName"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>目的城市: </label>
            <span v-text="routeInfo.endCityName"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>出发地址: </label>
            <span v-text="routeInfo.startAddress"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>目的地址: </label>
            <span v-text="routeInfo.endAddress"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>状态: </label>
            <span v-text="routeInfo.statusStr"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>线路类型: </label>
            <span v-text="routeInfo.typeStr"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>修改人: </label>
            <span v-text="routeInfo.updateUserName"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>修改时间: </label>
            <span v-text="routeInfo.updateTime"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="24">
            <label>站点信息: </label>
            线路包含{{ stationNumber }}个站点
            <!--            <el-button type="text" @click="showLineMapInfo">线路预览</el-button>-->
          </el-col>
        </el-row>
      </div>
      <!--      到达时间字符串-->
      <div style="margin-left: 110px">
        <el-table
          :data="routeStationList"
          ref="routeStationTable"
          border
          highlight-current-row
          stripe
          v-loading="loading"
        >
          <el-table-column align="center" type="index" width="60" label="序号" />
          <el-table-column
            :show-overflow-tooltip="true"
            label="类型"
            prop="stationType"
            width="120"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="站点名称"
            prop="stationName"
            width="180"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="到达时间"
            prop="arrTimeStr"
            width="140"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="里程数（公里）"
            prop="mileage"
            width="140"
            align="center"
          />
        </el-table>
      </div>
    </el-drawer>
    <div>
      <el-dialog
        ref="lineInfoMap"
        :title="lineMapTitle"
        :visible.sync="visibleLineInfoMap"
        :append-to-body="true"
        width="80%"
      >
        <div class="amap-contain">
          <div id="amapContainer" class="map"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import { getRoteInfoById } from '@/api/transport/routeset'
  export default {
    name: 'routeSetInfo',
    data() {
      return {
        lineMapTitle: '线路详情',
        visibleLineInfoMap: false,
        loadind: true,
        lineId: '',
        drawerVisible: false, // 是否展开详情
        stationLongLatitudeInfo: [],
        stationNumber: 0,
        routeInfo: {},
        routeStationList: [],
        stationType: ''
      }
    },
    mounted() {},
    methods: {
      showLineMapInfo() {
        this.visibleLineInfoMap = true
        setTimeout(() => {
          this.initMapDragRoute(() => {
            this.loadLineMap()
          })
        }, 3000)
      },
      // 初始化详情
      init(row) {
        this.drawerVisible = true
        this.lineId = row.id
        this.getRoteInfo(row.id)
      },

      // 根据id获取线路详情
      getRoteInfo(routeId) {
        getRoteInfoById(routeId).then((res) => {
          this.routeInfo = res.data
          this.routeStationList = res.data.lineStationVoList
          this.routeStationList.forEach((item) => {
            const longLatitude = []
            if (item.sort === 0) {
              item.stationType = '起点'
            }
            if (item.sort === this.routeStationList.length - 1) {
              item.stationType = '终点'
            }
            if (item.sort !== 0 && item.sort !== this.routeStationList.length - 1) {
              item.stationType = '经过'
            }
            longLatitude.push(parseFloat(item.longitude))
            longLatitude.push(parseFloat(item.latitude))
            this.stationLongLatitudeInfo.push(longLatitude)
          })
          this.stationNumber = res.data.lineStationVoList.length
        })
      },
      // 路由跳转
      jumpUrl(url, lineId) {
        this.drawerVisible = false
        this.$emit('onUrlChange', `${url}?id=${lineId}`)
        // this.$router.push({ path: url, query: { id: lineId } })
      },
      // 初始化线路地图
      initMapDragRoute(callBack) {
        const that = this
        that.AMap = window.AMap
        this.AMap.plugin(['AMap.ControlBar', 'AMap.DragRoute'], function () {
          // TODO  创建控件并添加
        })
        this.map = new this.AMap.Map('amapContainer', {
          zoom: 12,
          pitch: 80,
          rotation: -15,
          buildingAnimation: true // 楼块出现是否带动画
        })
        this.map.addControl(new this.AMap.ControlBar())
        if (callBack && typeof callBack == 'function') {
          callBack()
        }
      },
      // 加载路线
      loadLineMap() {
        const that = this
        that.AMap = window.AMap
        const path = []
        path.push([102.719804, 25.0151])
        path.push([102.947084, 25.080417])
        path.push([103.584312, 25.429818])
        path.push([103.797858, 25.492433])
        that.route = new that.AMap.DragRoute(that.map, path, that.AMap.DrivingPolicy.LEAST_FEE)
        that.route.search()
      }
    }
  }
</script>

<style lang="scss" scoped>
  #route-info-line {
    margin-left: 50px;
  }
  #edit-route-info {
    margin-left: 180px;
  }

  .amap-contain {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 80vh;
    display: flex;
    .map {
      width: 100%;
      height: 80vh;
    }
  }
</style>
